import React, { createContext, ReactNode, useState } from "react";
import { Navigate } from "react-router-dom";
import { Authenticate, Logout } from "../actions/OIDC";
import { User } from "../types/user";

interface AuthContextData {
  user?: User;
  logout: (e: React.MouseEvent) => void;
  authenticate: () => void;
}

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthContext = createContext<AuthContextData>(
  {} as AuthContextData
);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<User>();

  const authenticate = async () => {
    try {
      await Authenticate(setUser);
    } catch (error) {
      return <Navigate to="/error" />;
    }
  };

  const logoutFunction = (e: React.MouseEvent) => {
    e.preventDefault();
    Logout();
  };

  return (
    <AuthContext.Provider
      value={{
        user: user,
        logout: logoutFunction,
        authenticate: authenticate
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
